import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { get, post } from "../../services/Services";
import { FaSave, FaTimesCircle } from "react-icons/fa";

const API_BASE_URL = "https://ectech-software.com.ar/api/academy/events";
const COURSE_LEVELS_URL = "https://ectech-software.com.ar/api/academy/course-level";
const COURSE_TYPES_URL = "https://ectech-software.com.ar/api/academy/course-types";

function CoursesFormAdm({ ConfigId, setShowForm, refetch }) {
  const [formData, setFormData] = useState({
    name: "",
    typeId: "",         
    status: false,      
    teacher: "",
    courseDate: "",     
    levelId: "",        
    price: "",
  });

  const [courseLevels, setCourseLevels] = useState([]);
  const [courseTypes, setCourseTypes] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Cargar los niveles del curso
  useEffect(() => {
    const fetchCourseLevels = async () => {
      try {
        const response = await get(COURSE_LEVELS_URL);
        if (Array.isArray(response.data)) {
          setCourseLevels(response.data);
        } else {
          console.error("La respuesta de niveles no es un array:", response.data);
        }
      } catch (error) {
        console.error("Error al cargar los niveles:", error);
      }
    };

    fetchCourseLevels();
  }, []);

  // Cargar los TIPOS del curso
  useEffect(() => {
    const fetchCourseTypes = async () => {
      try {
        const response = await get(COURSE_TYPES_URL);
        if (Array.isArray(response.data)) {
          setCourseTypes(response.data);
        } else {
          console.error("La respuesta de tipos de cursos no es un array:", response.data);
        }
      } catch (error) {
        console.error("Error al cargar los tipos de cursos:", error);
      }
    };

    fetchCourseTypes();
  }, []);

  // Manejar cambios en los inputs
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Enviar formulario (POST)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setErrors({});
  
    const dataToSend = {
      name: formData.name,
      status: Boolean(formData.status),
      teacher: formData.teacher,
      type: {
        id: parseInt(formData.typeId)
      },
      courseDate: formData.courseDate,
      level: {
        id: parseInt(formData.levelId)
      },
      price: parseFloat(formData.price)
    };
  
    console.log("Enviando:", dataToSend); // 🧪 Verifica esto en consola
  
    try {
      await post(`${API_BASE_URL}/${ConfigId}/courses`, dataToSend);
      alert("Seminario creado correctamente.");
      refetch();
      setShowForm(false);
    } catch (error) {
      console.error("Error al crear el seminario:", error);
      setErrors({ general: "Hubo un error al crear el seminario." });
    } finally {
      setIsSubmitting(false);
    }
  };
  

  return (
    <div className="container mt-4">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "600px", margin: "auto" }}>
        <div className="card-header bg-primary text-white text-center">
          <h5 className="mb-0">Crear Seminario / Congreso</h5>
        </div>
        <div className="card-body">
          {errors.general && <div className="alert alert-danger">{errors.general}</div>}
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Nombre</label>
              <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} required />
            </div>

             <div className="mb-3">
              <label className="form-label">Tipo de Curso</label>
              <select name="typeId" className="form-control" value={formData.typeId} onChange={handleChange} required>
                <option value="">Seleccione un tipo...</option>
                {courseTypes.map((type) => (
                  <option key={type.id} value={type.id}>
                    {type.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Profesor /a</label>
              <input type="text" name="teacher" className="form-control" value={formData.teacher} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Fecha del Curso</label>
              <input type="date" name="courseDate" className="form-control" value={formData.courseDate} onChange={handleChange} required />
            </div>

            <div className="mb-3">
              <label className="form-label">Nivel del Curso</label>
              <select name="levelId" className="form-control" value={formData.levelId} onChange={handleChange} required>
                <option value="">Seleccione un nivel...</option>
                {courseLevels.map((level) => (
                  <option key={level.id} value={level.id}>
                    {level.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Precio</label>
              <input type="number" name="price" className="form-control" value={formData.price} onChange={handleChange} required />
            </div>

            
            <div className="form-check form-switch mb-3">
              <input
                type="checkbox"
                id="status"
                name="status"
                className="form-check-input"
                checked={formData.status}
                onChange={(e) =>
                  setFormData((prev) => ({ ...prev, status: e.target.checked ? 1 : 0 }))
                }
              />
              <label className="form-check-label" htmlFor="status">
                {formData.status ? "Activado" : "Desactivado"}
              </label>
            </div>

            <div className="d-flex justify-content-between">
              <button type="submit" className="btn btn-success" disabled={isSubmitting}>
                <FaSave /> {isSubmitting ? "Guardando..." : "Guardar"}
              </button>
              <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>
                <FaTimesCircle /> Cancelar
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default CoursesFormAdm;
